import IconDetail from "@/components/common/IconDetail";
import { cn } from "@/lib/utils";
import type { ExtendedInjectionViewT } from "@/types/database/events";
import { Syringe, User, UserSquare } from "lucide-react";

interface Props {
  injection: ExtendedInjectionViewT;
}

const InjectionMainInfo = ({ injection }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      <IconDetail
        icon={<UserSquare size={16} />}
        words={`Referred by: ${
          injection?.referring_clinician_name ?? "Unknown"
        }`}
      />
      {injection?.injecting_clinician_id && (
        <IconDetail
          icon={<User size={16} />}
          words={`Performed by: ${
            injection?.injecting_clinician_name ?? "Unknown"
          }`}
        />
      )}
      {injection?.injection_method && (
        <IconDetail
          icon={<Syringe size={16} />}
          words={`Method: ${injection?.injection_method ?? "Unknown"}`}
        />
      )}
    </div>
  );
};

export default InjectionMainInfo;
